// extracted by mini-css-extract-plugin
module.exports = {"anchor":"anchor--1p7c6","anchorText":"anchorText--3C4yi"};